<!--<div id="overlay">-->
<!--  <ap-loading *ngIf="startLoader" id="text" class="loader-class" [colorName]="'a-primary'">-->
<!--  </ap-loading>-->
<!--</div>-->
@if (startLoader) {
  <div class="loader-overlay">
    <div class="backdrop"></div>
    <ap-loading class="loader" [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
  </div>
}
<dst-create-disclosure-actions [isView]="false" (onSaveClick)="save()" [disabled]="false" [displayNotification]="showDREMsg" [notifMsg]="DREMsg"
  (onCancelClick)="clear()">
</dst-create-disclosure-actions>
<div class="form-template-wrapper" [ngClass]="showDREMsg ? 'msg-expanded' : ''">
  <div [formGroup]="form192" class="ap-form-field-my-wrapper">
    <dst-template-header [parentFormGroup]="form192" [overwriteFormName]="'STATEMENT REQUIRED PURSUANT TO SECTION 1.367(b)-1(c)(4) OF THE REGULATIONS'"
      (formOptionChanged)="onFormOptionChanged($event)" (consolGroupChanged)="OnConsolGroupChanged($event)">
    </dst-template-header>
    <div formGroupName="main" class="section-content ap-form-field-my-wrapper">
      <ol class="section-content">
        <li>
          The exchange is one to which Section 367(b) of the Internal Revenue Code of 1986, as amended, (the "Code") applies.
        </li>
        <li>
          <div class="">
            <div class="col-md-1 pr-0">
              On
            </div>
            <div class="col-md-4 p-0 date-align">
              @if (nameChangeChecked) {
                <app-date-picker-with-clear

                  [minDate]="beginDate"
                  [maxDate]="endDate"
                  [datePickerClass]="'required-field'"
                  [required]="true"
                  (dateChange)="dateChange($event, 1)"
                  (datePickerClick)="onDPOpen()"
                  (clearClick)="clearDate(1)"
                  [(ngModel)]="DisplayDate"
                  [ngModelOptions]="{standalone: true}">
                </app-date-picker-with-clear>
              }
              <!-- <div class="a-form-error" *ngIf="DisplayDate === '' || DisplayDate === null">
              Please Enter a Date
            </div> -->
          </div>
        </div>
        <br />
        <br />
        <dst-template-leid-selector [label]="'Please specify the LEID of the Transferor'" [labelId]="'100'"
          (onSelectedLEChanged)="onTransferorChanged($event)" class="required-field ent-label">
        </dst-template-leid-selector>
        <!-- <div class="a-form-error error-leid" *ngIf="transferor === undefined">
        Please specify a LEID of transferor
      </div> -->
      <div class="">
        <span class="template-color-blue">{{!transferor ? '' :
          transferor.ENTITY}}</span><span>&nbsp;EIN:&nbsp;</span><span class="template-color-blue">{{!transferor ?
          '' :
          (transferor.EIN ? transferor.EIN : 'N/A')}}</span><span>&nbsp;a&nbsp;</span><span class="template-color-blue">{{!transferor ? '' :
        transferor.COUNTRYINC + (transferor | taxtype: transferor?.TAXTYPECODE: entityNameChangeOnDate)}}</span><span>&nbsp;(the "Transferor"), transferred the net assets listed below
      to</span>
    </div>
    <dst-template-leid-selector [label]="'Please specify the LEID of the Transferee'" [labelId]="'100'"
      (onSelectedLEChanged)="onTransfereeChanged($event)" class="required-field ent-label">
    </dst-template-leid-selector>
    <!-- <div class="a-form-error error-leid" *ngIf="transferee === undefined">
    Please specify a LEID of Transferee
  </div> -->
  <div class="">
    <span class="template-color-blue">{{!transferee ? '' :
      transferee.ENTITY}}</span><span>&nbsp;EIN:&nbsp;</span><span class="template-color-blue">{{!transferee ?
      '' :
      (transferee.EIN ? transferee.EIN : 'N/A')}}</span><span>&nbsp;a&nbsp;</span><span class="template-color-blue">{{!transferee ? '' :
      transferee.COUNTRYINC }} </span><span>Corporation</span><span>,&nbsp;(the "Transferee") in an exchange pursuant to Sec.
    351 of the Code</span>
    <!-- <span class="template-color-blue">{{!transferee ? '' :
    transferee.ENTITY}}</span><span>&nbsp;EIN:&nbsp;</span><span class="template-color-blue">{{!transferee ?
    '' :
    (transferee.EIN ? transferee.EIN : 'N/A')}}</span><span>&nbsp;a&nbsp;</span><span class="template-color-blue">{{!transferee ? '' :
  transferee.COUNTRYINC + (transferee | taxtype: transferee?.TAXTYPECODE: entityNameChangeOnDate)}}</span><span>,&nbsp;(the "Transferee") in an exchange pursuant to Sec.
351 of the Code</span> -->
</div>

<br />
<div class="supp-info-wrapper">
  <div>Additional Information:</div>
  <ap-field [fieldId]="'550'" [title]="''" [hideTitleOnInput]="true">
                    <textarea appkit-field [(ngModel)]="section4text" [ngModelOptions]="{standalone: true}" aria-label="550"></textarea>
  </ap-field>
</div>
<table class="table-layout properties-table">
  <tbody>
    <tr>
      <td colspan="3">
      </td>
      <td>
        <ap-dropdown [list]="propertyValBasisOptions" [selectType]="'single'" [title]="'** Select a basis **'" [inputAriaLabel]="'** Select a basis **'"
          (onSelect)="selectBasisOption($event)"
          [hideTitleOnInput]="true" [(ngModel)]="selectedBasisItem" [ngModelOptions]="{standalone: true}">
          @for (item of propertyValBasisOptions; track $index) {
            <ap-dropdown-list-item #dropdownListItem [item]="item"
              [ariaLabel]="setAriaLabel(item, '** Select a basis **')"
            (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
          }
        </ap-dropdown>
      </td>
      <td></td>
    </tr>
    <tr>
      <td colspan="3"></td>
      <td><span class="thirteen">Basis</span></td>
    </tr>
    <tr>
      <td colspan="2"></td>
      <td class="header-column"><span>Description</span></td>
      <td>
        <ap-dropdown [list]="currencyOptions" [selectType]="'single'" [showSearchbox]="true" [title]="'** Select Currency **'" [inputAriaLabel]="'** Select Currency **'"
          (onSelect)="currencyOneChange($event)" class="currency-dropdown field-full-width"
          [hideTitleOnInput]="true" [(ngModel)]="selectedCurrencyItem" [ngModelOptions]="{standalone: true}">
          @for (item of currencyOptions; track $index) {
            <ap-dropdown-list-item #dropdownListItem [item]="item"
              [ariaLabel]="setAriaLabel(item, '** Select Currency **')"
            (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
          }
        </ap-dropdown>
      </td>
    </tr>
    <ng-container formArrayName="additionalPropsDetails">
      @for (p of additionalPropsDetails.controls; track $index; let i = $index) {
        <tr>
          <ng-container [formGroupName]="i">
            <td style="width: 3%;">
              @if (i > 0) {
                <ap-button class="btn-plus-minus" [btnType]="'secondary'" [compact]="true"
                  [icon]="'minus-outline'" [add]="true"
                  (onClick)="removeAdditionalPropDetailsAt(i)">
                </ap-button>
              }
            </td>
            <td style="width: 3%;">
              <ap-button class="btn-plus-minus" [btnType]="'secondary'" [compact]="true"
                [icon]="'plus-outline'" [add]="true"
                (onClick)="addAdditionalPropDetails()">
              </ap-button>
            </td>
            <td style="width: 65%;">
              <ap-field [title]="''" [fieldId]="i + 'a'" [styleClass]="'number-field hide-label'" [hideTitleOnInput]="true">
                    <input appkit-field formControlName="description" [attr.aria-label]="i + 'a'" />
              </ap-field>
            </td>
            <td>
              <ap-field [title]="''" [fieldId]="i + 'b'" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field hide-label'"
                [hideTitleOnInput]="true">
                    <input appkit-field onlyDigitsDecimal formControlName="transferorBasis" [attr.aria-label]="i + 'b'" />
              </ap-field>
            </td>
          </ng-container>
        </tr>
      }
    </ng-container>
  </tbody>
</table>
</li>
<li>
  <div class="inline-paragraphs">
    <gtw-nullable-number-input
      [inlineBlock]="true"
      [id]="'380'"
      [minNum]="0"
      class="required-field number-field"
      [(ngModel)]="Shares"
      [ngModelOptions]="{standalone: true}">
    </gtw-nullable-number-input>
    shares of the Transferee were issued to the Transferor in the exchange. The Transferor owned
    <gtw-nullable-number-input
      [inlineBlock]="true"
      [id]="'381'"
      [minNum]="0"
      class="number-field"
      [(ngModel)]="PercentageX"
      [ngModelOptions]="{standalone: true}">
    </gtw-nullable-number-input> % and
    <gtw-nullable-number-input
      [inlineBlock]="true"
      [id]="'381'"
      [minNum]="0"
      class="number-field"
      [(ngModel)]="PercentageY"
      [ngModelOptions]="{standalone: true}">
    </gtw-nullable-number-input> % of the
    @if (stockType.length > 0) {
      <ap-dropdown
        [list]="stockType" [selectType]="'single'" [showSearchbox]="true"
        [title]="'** select stock type **'" [inputAriaLabel]="'** select stock type **'" [optionName]="'text'"
        class="a-dropdown inline-dropdown show-label select-dropdown field-full-width"
        (onSelect)="selectStockType($event)" [hideTitleOnInput]="true"
        [(ngModel)]="selectedStockTypeItem" [ngModelOptions]="{standalone: true}">
        @for (item of stockType; track trackByDropdownValue($index, item)) {
          <ap-dropdown-list-item #dropdownListItem
            [item]="item" [optionName]="'text'"
            [ariaLabel]="setAriaLabel(item, '** select stock type **')"
          (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
        }
      </ap-dropdown>
    }
    shares of the Transferee immediately before and after the exchange, respectively.
  </div>
  <!-- <div class="a-form-error" *ngIf="Shares === ''">
  Please Enter number of Shares
</div> -->
<!-- <div class="a-form-error" *ngIf="selectedStockType === -1">
Please select Stock Type
</div> -->
</li>
<li>
  None.
</li>
<li>
  For information required pursuant to regulations under Code Section 351, see the separate statement.
</li>
<li>
  Any information required to be furnished with respect to the exchange under sections 6038, 6038B, or 6046, or
  the regulations under those sections has been provided with this tax return on Form 5471, Information Return
  of U.S. Persons with Respect to Certain Foreign Corporations.
</li>
<li>
  Not applicable.
</li>
</ol>

<dst-template-leid-selector [isBranchEntity]="true" [label]="'Please specify the LEID of the Branch Entity:'"
  [labelId]="'3'" (onSelectedLEChanged)="onBranchEntityChanged($event)" class="entity-label">
</dst-template-leid-selector>
<div class="entity-details">
  <span>Branch Entity Name:</span><span class="template-color-blue">{{!branchEntity ? '' :
branchEntity.ENTITY}}</span>
</div>
<div class="d-flex" style="margin-top: 15px;">
  <span>LEIDs: </span>
  <div>
    @if (transferee) {
      <span class="template-color-blue">{{ transferee.LEID }}</span>
      }@if (transferor) {
      <span>
      / </span>
      }@if (transferor) {
      <span class="template-color-blue">{{ transferor.LEID }}</span>
    }
  </div>
</div>
</div>
</div>
</div>
